module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/下载引流卡片-文本标题.4e191.png";